import store from '../store/'

export default {
  install(Vue) {
    Vue.mixin({
      beforeRouteEnter(to, from, next) {
        next(vm => {
          const { navbar } = vm.$options
          const hasNavbar = typeof navbar !== 'undefined' ? navbar : true
          store.commit('app/SET_NAVBAR', hasNavbar)
        })
      }
    })
  }
}